import {
  GET_LIST_MAU_IN_NHANVAY,
  GET_LIST_MAU_IN_NHANVAY_SUCCESS,
  GET_LIST_MAU_IN_NHANVAY_FAILURE,
  GET_NOI_DUNG_IN_NHANVAY,
  GET_NOI_DUNG_IN_NHANVAY_SUCCESS,
  GET_NOI_DUNG_IN_NHANVAY_FAILURE,
} from "./actionTypes";

export const getListMauInNhanVay = () => ({
  type: GET_LIST_MAU_IN_NHANVAY,
});

export const getListMauInNhanVaySuccess = (data) => ({
  type: GET_LIST_MAU_IN_NHANVAY_SUCCESS,
  payload: data,
});

export const getListMauInNhanVayFailure = () => ({
  type: GET_LIST_MAU_IN_NHANVAY_FAILURE,
});

export const getNoiDungInNhanVay = (dataSearch) => ({
  type: GET_NOI_DUNG_IN_NHANVAY,
  dataSearch,
});

export const getNoiDungInNhanVaySuccess = (data) => ({
  type: GET_NOI_DUNG_IN_NHANVAY_SUCCESS,
  payload: data,
});

export const getNoiDungInNhanVayFailure = () => ({
  type: GET_NOI_DUNG_IN_NHANVAY_FAILURE,
});
